import React from 'react';
import { StickyHeader } from '../components/StickyHeader';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductDetailsSection } from '../components/ProductDetailsSection';
import { OfferSection } from '../components/OfferSection';
import { MidPageCTA } from '../components/MidPageCTA';
import { TestimonialSection } from '../components/TestimonialSection';
import { WhoIsThisFor } from '../components/WhoIsThisFor';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-slate-950 text-slate-200 font-sans selection:bg-brand-orange selection:text-white" data-id="element-325">
      <StickyHeader data-id="element-326" />

      <main data-id="element-327">
        <HeroSection data-id="element-328" />
        <ProblemSection data-id="element-329" />
        <MidPageCTA data-id="element-330" />
        <SolutionSection data-id="element-331" />
        <TestimonialSection data-id="element-332" />
        <WhoIsThisFor data-id="element-333" />
        <ProductDetailsSection data-id="element-334" />
        <FAQSection data-id="element-335" />
        <OfferSection data-id="element-336" />
        <FinalCTA data-id="element-337" />
      </main>

      <Footer data-id="element-338" />
    </div>;
}